module.exports = __webpack_public_path__ + "img/16m003-02.113ced0d.png";